import api from './api';

const affiliateService = {
  // Get affiliate's own profile (for affiliate users)
  getProfile: async () => {
    try {
      const response = await api.get('/affiliates/profile');
      return response.data;
    } catch (error) {
      console.error('Error fetching affiliate profile:', error);
      throw error;
    }
  },

  // Update affiliate's own profile (for affiliate users)
  updateProfile: async (affiliateData) => {
    try {
      const response = await api.patch('/affiliates/profile', {
        affiliateData
      });
      return response.data;
    } catch (error) {
      console.error('Error updating affiliate profile:', error);
      throw error;
    }
  },

  // Get all affiliates
  getAffiliates: async () => {
    try {
      const response = await api.get('/affiliates');
      return response.data;
    } catch (error) {
      console.error('Error fetching affiliates:', error);
      throw error;
    }
  },

  // Update affiliate status
  updateAffiliateStatus: async (affiliateId, status) => {
    try {
      const response = await api.patch(`/affiliates/${affiliateId}/status`, {
        status
      });
      return response.data;
    } catch (error) {
      console.error('Error updating affiliate status:', error);
      throw error;
    }
  },

  // Update affiliate data
  updateAffiliate: async (affiliateId, affiliateData) => {
    try {
      const response = await api.patch(`/affiliates/${affiliateId}`, {
        affiliateData
      });
      return response.data;
    } catch (error) {
      console.error('Error updating affiliate:', error);
      throw error;
    }
  },

  // Delete affiliate
  deleteAffiliate: async (affiliateId) => {
    try {
      const response = await api.delete(`/affiliates/${affiliateId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting affiliate:', error);
      throw error;
    }
  }
};

export default affiliateService; 